module.exports = __webpack_public_path__ + "static/media/experience_logo.ec61a071.jpg";